module.exports = __webpack_public_path__ + "static/img/ic_setting@2x.17c96c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_setting@2x.png
// module id = S8sQ
// module chunks = 1